<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>

    <el-card class="box-card mt-2">

      <el-tabs v-model="activeName" type="card" @tab-click="onTabClick">
        <el-tab-pane label="用户管理" name="first">
          <el-row>
            <p>注意时间是区域是不包含</p>
          </el-row>
          <el-row>
            <el-date-picker
                  v-model="sdate"
                  type="date"
                  :value-format="df"
                  placeholder="选择起始日期">
                </el-date-picker>
          </el-row>
          <el-row class="mt-2">
            <el-date-picker
                  v-model="edate"
                  type="date"
                  :value-format="df"
                  placeholder="选择结束日期">
                </el-date-picker>
          </el-row>
          <el-row class="mb-1">
            <el-checkbox v-model="retired" @change="onRetiredChanged" >包含退休人员</el-checkbox>
          </el-row>

          <el-row class="mb-1">
            <el-checkbox v-model="fresh" @change="onFreshChanged" >更新数据</el-checkbox>
          </el-row>

          <el-row class="mt-2">
            <ExportClassUnitTotalBtn ref="exportClassUnitTotalBtn"></ExportClassUnitTotalBtn>
          </el-row>
          
          <el-row class="mt-2">
            <ExportUserTotalBtn ref="exportUserTotalBtn"></ExportUserTotalBtn>
          </el-row>

          <el-row class="mt-2">
            <ExportScheduleDetailByUnitBtn ref="ExportScheduleDetailByUnitBtnRef"></ExportScheduleDetailByUnitBtn>
          </el-row>

        </el-tab-pane>
        <el-tab-pane label="详细记录" name="second">        
            <ExportDetail></ExportDetail>
        </el-tab-pane>
        <el-tab-pane label="导出详细记录" name="third">
            <el-row class="mt-2">
              <ExportDetails></ExportDetails>
            </el-row>
        </el-tab-pane>
        <el-tab-pane label="单位课程记录" name="fourth">
            <el-row class="mt-2">
              <ExportClassUnitSche></ExportClassUnitSche>
            </el-row>
        </el-tab-pane>
        <el-tab-pane label="支部课程记录" name="five">
            <el-row class="mt-2">
              <ExportPartyOrgSche></ExportPartyOrgSche>
            </el-row>
        </el-tab-pane>
        <el-tab-pane label="通过指定用户与课程导出" name="six">
          <ExportUserAndScheduling></ExportUserAndScheduling>
        </el-tab-pane>
        <!-- <el-tab-pane label="输入框导入" name="seven">
          <ExportArea></ExportArea>
        </el-tab-pane> -->
        <el-tab-pane label="依据学员和学习班导出学时信息(导出学员参与该学习班的总学时以及详细)" name="eight">
          <ExportByUserAndStudyClass></ExportByUserAndStudyClass>
        </el-tab-pane>
      </el-tabs>

    </el-card>
  </div>
</template>



<script>

import { ExportClassUnitTotalBtn,ExportUserTotalBtn,
ExportGWYCurrent,ExportByClassUnit,ExportClassUnitSche,
ExportPartyOrgSche,ExportScheduleDetailByUnitBtn,ExportUserAndScheduling,
ExportArea,ExportByUserAndStudyClass,ExportDetails
 } from "@/views/module/export/comp"
import ExportDetail from "@/views/module/export/comp/ExportDetail.vue"


export default{

  name: 'exportQuick',

  components: {
    ExportClassUnitTotalBtn,
    ExportScheduleDetailByUnitBtn,
    ExportUserTotalBtn,
    ExportGWYCurrent,
    ExportByClassUnit,
    ExportClassUnitSche,
    ExportPartyOrgSche,
    ExportUserAndScheduling,
    ExportArea,
    ExportByUserAndStudyClass,
    ExportDetail,
    ExportDetails
  },

  data(){
    return {
      // activeName: "first",
      activeName: "first",
      sdate: "",
      edate: "",
      retired : false,
      fresh : false,
      df: "yyyy-MM-dd",
    }
  },

  watch:{
    sdate(oldVal,newVal) {
      this.updateComps()
    },
    edate(oldVal,newVal) {
      this.updateComps()
    }

  },
  
  methods:{
    onTabClick(tab,event){

    },
    onRetiredChanged(){
      this.updateComps();
    },
    onFreshChanged(){
      this.updateComps();
    },
    updateComps(){
      this.$refs.exportClassUnitTotalBtn.setData(this.sdate,this.edate,this.retired,this.fresh)
      this.$refs.exportUserTotalBtn.setData(this.sdate,this.edate,this.retired,this.fresh)
      this.$refs.ExportScheduleDetailByUnitBtnRef.setData(this.sdate,this.edate)
    }
  },


  mounted(){
    this.updateComps();
  }
}








</script>

<style scoped>
</style>